import { attr } from '@ember-data/model';
import IntegrationLogBase from 'eflex/models/integration-log-base';

export default class IntegrationOutboxLog extends IntegrationLogBase {
  @attr('string') OutboxId;
}
